import React, { useEffect } from 'react';
import Routes from './Routes/index';

//import Custom Style scss
import './assets/scss/themes.scss';
import { store } from './Redux/store';
import { Provider } from 'react-redux';
import { CookiesProvider } from 'react-cookie';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import { base_url } from './apis/constants';
import SignalRApp from './SignalR';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import GlobalCORSModal from './pages/404Component/GlobalCORSModal';

function App() {
  var layoutMode = document.body.getAttribute('data-layout-mode');
  let persistor = persistStore(store);
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 5 * 60 * 1000, // 5 minutes
        cacheTime: 10 * 60 * 1000 // 10 minutes
      }
    }
  });
  return (
    <React.Fragment>
      <GlobalCORSModal />
      <CookiesProvider>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <QueryClientProvider client={queryClient}>
              <SignalRApp />
            </QueryClientProvider>
          </PersistGate>
        </Provider>
      </CookiesProvider>
    </React.Fragment>
  );
}

export default App;
